import { Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { CdkPortal } from "@angular/cdk/portal";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { Subscription } from "rxjs";

import { DestroyableMixin } from "../../mixins/destroyable.mixin";

import { NotificationPaneModel } from "./notification-pane.model";
import { NotificationPaneService } from "./notification-pane.service";

/* eslint-disable @typescript-eslint/no-unsafe-argument */

@Component({
    selector: "pcg-ng-notification-pane",
    templateUrl: "./notification-pane.component.html"
})
export class NotificationPaneComponent extends DestroyableMixin(EmptyInstance) implements OnInit, OnDestroy {
    @ViewChild(CdkPortal, { read: CdkPortal, static: false })
    private _templateRef: CdkPortal;
    private _overlayRef: OverlayRef;

    private _onShowSubscription: Subscription;
    private _onHideSubscription: Subscription;

    public notifications: Array<NotificationPaneModel> = new Array<NotificationPaneModel>();

    public constructor(
        private _overlay: Overlay,
        private _notificationService: NotificationPaneService
    ) {
        super();
    }

    public ngOnInit(): void {
        const config: OverlayConfig = {
            positionStrategy: this._overlay.position().global().top(),
            panelClass: "pcg-notification-overlay-pane"
        };

        this._overlayRef = this._overlay.create(config);

        this._onShowSubscription = this._notificationService.notificationToShow.subscribe(this.show.bind(this));
        this._onHideSubscription = this._notificationService.notificationToHide.subscribe(this.hide.bind(this));
    }

    public ngOnDestroy(): void {
        this.destroy();
        this._overlayRef.dispose();
    }

    public hideNotificationButton_onClick(notification: NotificationPaneModel): void {
        this._notificationService.hide(notification);
    }

    private show(notification: NotificationPaneModel): void {
        this.notifications.push(notification);

        if (!this._overlayRef.hasAttached()) {
            this._overlayRef.attach(this._templateRef);
        }
    }

    private hide(notification: NotificationPaneModel): void {
        const index = this.notifications.indexOf(notification);

        if (index > -1) {
            this.notifications.splice(index, 1);
        }

        if (!this.notifications.length) {
            this.cleanUp();
        }
    }

    private cleanUp(): void {
        if (this._overlayRef.hasAttached()) {
            this._overlayRef.detach();
        }
    }
}
